import { AUTH_SERVICE_DATA, AUTH_SERVICE_TYPE } from '@/modules/UserProfile/components/Profile/Sections/constants';
import { rServices } from '@/plugins/api';

export const USER_DUPLICATE_STATUS_KEY = {
  notProceed: 0,
  merged: 1,
  mergeInitiate: 2,
  notDuplicate: 3,
  inMerge: 4,
  mergeFailed: 5,
  wait: 6,
};

export const USER_DUPLICATE_MAP = {
  [USER_DUPLICATE_STATUS_KEY.notProceed]: {
    id: USER_DUPLICATE_STATUS_KEY.notProceed,
    name: 'Не обработано',
  },
  [USER_DUPLICATE_STATUS_KEY.merged]: {
    id: USER_DUPLICATE_STATUS_KEY.merged,
    name: 'Процесс слияния успешно произведен',
  },
  [USER_DUPLICATE_STATUS_KEY.mergeInitiate]: {
    id: USER_DUPLICATE_STATUS_KEY.mergeInitiate,
    name: 'Была произведена инициация слияния',
  },
  [USER_DUPLICATE_STATUS_KEY.notDuplicate]: {
    id: USER_DUPLICATE_STATUS_KEY.notDuplicate,
    name: 'Не является дубликатом',
  },
  [USER_DUPLICATE_STATUS_KEY.inMerge]: {
    id: USER_DUPLICATE_STATUS_KEY.inMerge,
    name: 'В процессе слияния',
  },
  [USER_DUPLICATE_STATUS_KEY.mergeFailed]: {
    id: USER_DUPLICATE_STATUS_KEY.mergeFailed,
    name: 'Процесс слияния завершился с ошибкой',
  },
  [USER_DUPLICATE_STATUS_KEY.wait]: {
    id: USER_DUPLICATE_STATUS_KEY.wait,
    name: 'В ожидании начала слияния',
  },
};

export const USER_DUPLICATES = Object.values(USER_DUPLICATE_MAP);

export const USER_DUPLICATE_SOURCE_KEY = {
  email: 1,
  vk: 2,
  apple: 3,
  telegram: 4,
  yandex: 5,
  max: 6,
  dispatcher: 7,
};

export const USER_DUPLICATE_SOURCE_MAP = {
  [USER_DUPLICATE_SOURCE_KEY.dispatcher]: {
    id: USER_DUPLICATE_SOURCE_KEY.dispatcher,
    name: 'Через диспетчер',
    backendField: 'is_available_dispatcher_merge',
    method: null,
    icon: '$ui-document-check',
    iconColor: 'ui-primary',
  },
  [USER_DUPLICATE_SOURCE_KEY.email]: {
    id: USER_DUPLICATE_SOURCE_KEY.email,
    name: 'Email',
    backendField: 'is_available_email_merge',
    method: (payload) => rServices.userDuplicates.initiateEmail(payload),
    successMessage: 'Запрос на объединение профилей инициирован',
    icon: '$ui-email',
    iconColor: 'ui-primary',
  },
  [USER_DUPLICATE_SOURCE_KEY.vk]: {
    id: USER_DUPLICATE_SOURCE_KEY.vk,
    name: 'Вконтакте',
    backendField: 'is_available_vk_merge',
    method: () => rServices.user.getSimpleAuthUriVk({ data: { is_attaching: true } }),
    successMessage: 'Запрос на объединение профилей инициирован',
    icon: '$ui-vk',
    iconColor: AUTH_SERVICE_DATA[AUTH_SERVICE_TYPE.vk].color,
  },
  [USER_DUPLICATE_SOURCE_KEY.apple]: {
    id: USER_DUPLICATE_SOURCE_KEY.apple,
    name: 'Apple',
    backendField: 'is_available_apple_merge',
    method: () => rServices.user.getSimpleAuthUriApple({ data: { is_attaching: true } }),
    successMessage: 'Запрос на объединение профилей инициирован',
    icon: 'mdi-apple',
    iconColor: 'ui-primary',
  },
  [USER_DUPLICATE_SOURCE_KEY.telegram]: {
    id: USER_DUPLICATE_SOURCE_KEY.telegram,
    name: 'Телеграм',
    backendField: 'is_available_telegram_merge',
    method: () => rServices.user.getSimpleAuthUriTg({ data: { is_attaching: true } }),
    successMessage: 'Запрос на объединение профилей инициирован',
    icon: '$ui-tg',
    iconColor: 'ui-primary',
  },
  [USER_DUPLICATE_SOURCE_KEY.yandex]: {
    id: USER_DUPLICATE_SOURCE_KEY.yandex,
    name: 'Яндекс',
    backendField: 'is_available_yandex_merge',
    method: () => rServices.user.getSimpleAuthUriYandex({ data: { is_attaching: true } }),
    successMessage: 'Запрос на объединение профилей инициирован',
    icon: '$ui-yandex',
    iconColor: AUTH_SERVICE_DATA[AUTH_SERVICE_TYPE.yandex].color,
  },
  [USER_DUPLICATE_SOURCE_KEY.max]: {
    id: USER_DUPLICATE_SOURCE_KEY.max,
    name: 'Max',
    backendField: 'is_available_max_merge',
    method: null,
    successMessage: 'Запрос на объединение профилей инициирован',
    icon: '$ui-max',
    iconColor: AUTH_SERVICE_DATA[AUTH_SERVICE_TYPE.max].color,
  },
};

export const USER_DUPLICATE_MERGE_TYPE = {
  email: 1,
  vk: 2,
  apple: 3,
  telegram: 4,
  max: 5,
  organizer: 6,
  yandex: 7,
  dispatcher: 8,
};

export const USER_DUPLICATES_LOCAL_STORAGE_KEY = 'userDuplicatesMerge';

export const USER_AUTH_ATTACH_LOCAL_STORAGE_KEY = 'userAuthAttach';
